import ApplicationError from './application-error';
import ValidationError from './validation-error';
import FetchError from './fetch-error';
import ErrorHandlerHelper from '../helpers/ErrorHandlerHelper';

export const onApplicationError = (err: ApplicationError): void => {
  ErrorHandlerHelper.handleError(
    err,
    {
      logToConsole: true,
      showSwal: true,
      swalMessage: window.errorTexts[err.errorMessage as keyof typeof window.errorTexts] as string,
    },
  );
};

export const onValidationError = (err: ValidationError): void => {
  ErrorHandlerHelper.handleError(
    err,
    {
      logToConsole: true,
      showSwal: !!err.errorMessage,
      swalMessage: err.errorMessage ? window.errorTexts[err.errorMessage] as string : undefined,
    },
  );
};

export const onFetchError = (err: FetchError): void => {
  ErrorHandlerHelper.handleError(
    err,
    {
      logToConsole: true,
    },
  );
};
